import { render } from "./CoachRegistration.vue?vue&type=template&id=5e713bef"
import script from "./CoachRegistration.vue?vue&type=script&lang=js"
export * from "./CoachRegistration.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__